import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    initialSearch,
    SearchContext,
    SearchContextType,
    useSearchClinic,
    useSearchPCP,
} from '~/services';
import { prepareSearchQueryString, searchFieldIsFiltered } from '~/util';

const displayNames = {
    clinic: 'Clinic',
    PCP: 'PCP',
    firstName: 'First Name',
    lastName: 'Last Name',
    DOB: 'DOB',
    memberID: 'Member ID',
    phone: 'Phone',
    planType: 'Plan Type',
    riskBand: 'Risk Band',
    riskFactor: 'Social Risk Factor',
    openGaps: 'Open Gaps',
    GMPI: 'GMPI',
    insurance: 'Insurance',
    disenrolled: 'PCP Assignment',
};
type DisplayNameKey = keyof typeof displayNames;

export function FilterBadges() {
    const history = useHistory();
    const { searchValues, setSearchValues, resetPagination } = React.useContext(
        SearchContext
    ) as SearchContextType;
    const { clinic, setClinic } = useSearchClinic();
    const { PCP, setPCP } = useSearchPCP();

    function remove(key: DisplayNameKey) {
        resetPagination();
        if (key === 'clinic') {
            setClinic(null);
        } else if (key === 'PCP') {
            setPCP(null);
        }
        setSearchValues((prev) => ({ ...prev, filter: null, [key]: initialSearch[key] }));
        // Make sure to update the location search values in addition to the state
        history.replace(
            `/patients?${prepareSearchQueryString({
                ...searchValues,
                clinic,
                PCP,
                [key]: initialSearch[key],
                redirect: false,
            })}`
        );
    }

    function display(key: DisplayNameKey) {
        return (
            <span className="badge bg-primary badge-font-90 me-2" key={key}>
                {displayNames[key]}
                <button type="button" className="ms-1 pe-0 icon-button" onClick={() => remove(key)}>
                    <i className="fa-solid fa-remove text-white">
                        <span className="sr-only">Remove</span>
                    </i>
                </button>
            </span>
        );
    }

    return (
        <div className="col">
            {clinic !== null && clinic.length > 0 && display('clinic')}
            {PCP !== null && PCP.length > 0 && display('PCP')}
            {Object.keys(searchValues).map(
                (key: DisplayNameKey) =>
                    !['clinic', 'PCP'].includes(key) &&
                    displayNames?.[key] &&
                    searchFieldIsFiltered(key, initialSearch, searchValues) &&
                    display(key)
            )}
        </div>
    );
}
